import { render } from "./AddPermissionGroup.vue?vue&type=template&id=4f2fa9aa&scoped=true&ts=true"
import script from "./AddPermissionGroup.vue?vue&type=script&lang=ts"
export * from "./AddPermissionGroup.vue?vue&type=script&lang=ts"

import "./AddPermissionGroup.vue?vue&type=style&index=0&id=4f2fa9aa&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2fa9aa"]])

export default __exports__